import styled from 'styled-components';
import { ButtonModalProps } from './types/modal';

export const StyledButton = styled.button<ButtonModalProps>`
  padding: 8px 16px;
  height: 40px;
  border-radius: 4px;
  border: none;
  min-width: 150px;
  max-width: 100%;
  background-color: #007bff;
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  font-size: 14px;
  font-weight: 500;
  font-family: 'Jost', sans-serif;
  line-height: 26.01px;
  white-space: nowrap;

  text-transform: uppercase;

  svg {
    font-size: 20px;
  }

  animation: all 0.25s ease-in;

  &:disabled {
    opacity: 80%;
    cursor: not-allowed;
    &:hover {
      opacity: 80%;
    }
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6b7280;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: #f3f4f6;
    color: #374151;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
  }
`;
